import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_V_L, stopPropagation, TS_ErrorBoundary } from '@nu-art/thunderstorm-frontend/index';
import { resolveContent } from '@nu-art/ts-common';
import { TS_Workspace } from '@nu-art/ts-workspace-frontend/index';
import { Sandbox_Header } from '../Sandbox_Header/index.js';
import './Page_BaseSandbox.scss';
export class Page_BaseSandbox extends ComponentSync {
    getHeader() {
        return 'Sandbox';
    }
    render() {
        const workspace = resolveContent(this.workspace);
        return _jsx(TS_ErrorBoundary, { children: _jsxs(LL_V_L, { id: "sandbox", onContextMenu: stopPropagation, children: [_jsx(Sandbox_Header, { label: this.getHeader() }), _jsx(TS_Workspace, { id: workspace.id, workspaceKey: workspace.key, renderers: workspace.renderers, instances: workspace.instances })] }) });
    }
}
//# sourceMappingURL=Page_BaseSandbox.js.map